// extracted by mini-css-extract-plugin
export var avatar_card = "AvatarCard-module--avatar_card--w1CHV";